<template>
  <div id="main">
    <h1>
      <transition
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated faster fadeOut"
      >
        <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
      </transition>Sva glasanja
    </h1>
    <poll-table></poll-table>
  </div>
</template>

<script>
import PollTable from '@/components/table/TablePolls.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    PollTable
  },
  created() {
    this.getAllPolls();
  },
  methods: {
    ...mapActions('table', ['getAllPolls']),
    back() {
      this.$router.back();
    }
  }
};
</script>

<style>
#main {
  padding: 0px 10px;
  padding-top: 50px;
}
h1 {
  text-align: center;
  padding-bottom: 20px;
}
</style>
